module.exports = __webpack_public_path__ + "static/3-e4210aaa94feb30de4e6f456c11527b4.jpeg";